import type { BasicCustomMailOptionalItemOverrideInput, LangCode } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import { QuestionEmailTemplateItem } from "../_shared/components/email-template-item";

import type { ProductDayTripPlanI18nFormModel } from "../../../../../../model";

type Props = {
	isEdited: boolean;
	hasError: boolean;
	hotelEmailAddress: string;
	atCheckOutAfter_01days: ForAutoGenerator<BasicCustomMailOptionalItemOverrideInput, "">;
	onSetAtCheckOutAfter_01daysForText: (value: string) => void;
	onSendTestEmailCheckOutAfter_01days: ({ lang, email }: { lang: LangCode; email: string }) => Promise<void>;
	lang: LangCode;

	title?: string;
	guide?: string;

	/** 基本メール設定の文言 */
	basicCustomMailSetting: ProductDayTripPlanI18nFormModel["QueryData"]["basicCustomMailSetting"];
	/** デフォルトプランメール設定 */
	defaultPlanCustomMailSetting: ProductDayTripPlanI18nFormModel["QueryData"]["defaultPlanCustomMailSetting"];
};

export const ForCheckOutEmailTemplates = ({
	isEdited,
	hasError,
	hotelEmailAddress,
	atCheckOutAfter_01days,
	onSetAtCheckOutAfter_01daysForText,
	onSendTestEmailCheckOutAfter_01days,
	lang,
	title: _title,
	guide: _guide,
	basicCustomMailSetting,
	defaultPlanCustomMailSetting,
}: Props) => {
	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title=""
			guide=""
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<div className="space-y-6">
					<QuestionEmailTemplateItem
						lang={lang}
						label={"翌日"}
						hotelEmailAddress={hotelEmailAddress}
						textValue={atCheckOutAfter_01days?.text.value}
						textErrorMessage={atCheckOutAfter_01days?.text.error}
						handleChangeText={onSetAtCheckOutAfter_01daysForText}
						sendTestEmail={onSendTestEmailCheckOutAfter_01days}
						isOverride={defaultPlanCustomMailSetting?.atCheckOutAfter_01days?.override ?? false}
						basicCustomMailSetting={basicCustomMailSetting?.atCheckOutAfter_01days}
					/>
				</div>
			}
		/>
	);
};

ForCheckOutEmailTemplates.displayName = "ForCheckOutEmailTemplates";
